(() => {
  const galleries = document.querySelectorAll('[data-team-culture]');

  galleries.forEach((section) => {
    const photos = [...section.querySelectorAll('[data-team-culture-photo]')];
    const previous = section.querySelector('[data-team-culture-prev]');
    const next = section.querySelector('[data-team-culture-next]');
    const current = section.querySelector('[data-team-culture-current]');
    const progress = section.querySelector('[data-team-culture-progress]');

    if (!photos.length) return;

    let activeIndex = Math.max(0, photos.findIndex((photo) => photo.getAttribute('aria-pressed') === 'true'));
    const slots = ['top', 'bottom-start', 'bottom-end'];

    const render = (index, moveFocus = false, animate = false) => {
      const previousRects = animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? new Map(photos.map((photo) => [photo, photo.getBoundingClientRect()]))
        : null;

      activeIndex = (index + photos.length) % photos.length;
      let secondaryIndex = 0;

      photos.forEach((photo, photoIndex) => {
        const isActive = photoIndex === activeIndex;
        photo.dataset.slot = isActive ? 'active' : slots[secondaryIndex++];
        photo.setAttribute('aria-pressed', String(isActive));
        photo.setAttribute('aria-label', `${isActive ? 'Currently showing' : 'Show'} ${photo.dataset.title}`);
      });

      if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
      if (progress) progress.style.setProperty('--team-culture-progress', String((activeIndex + 1) / photos.length));

      if (previousRects) {
        photos.forEach((photo) => {
          const previousRect = previousRects.get(photo);
          const nextRect = photo.getBoundingClientRect();
          const deltaX = previousRect.left - nextRect.left;
          const deltaY = previousRect.top - nextRect.top;
          const scaleX = previousRect.width / nextRect.width;
          const scaleY = previousRect.height / nextRect.height;

          photo.getAnimations().forEach((animation) => animation.cancel());
          photo.animate([
            { transform: `translate(${deltaX}px, ${deltaY}px) scale(${scaleX}, ${scaleY})`, transformOrigin: 'top left' },
            { transform: 'none', transformOrigin: 'top left' }
          ], {
            duration: 520,
            easing: 'cubic-bezier(.2, .75, .2, 1)'
          });
        });
      }

      if (moveFocus) photos[activeIndex].focus({ preventScroll: true });
    };

    photos.forEach((photo, index) => {
      photo.addEventListener('click', () => render(index, false, true));
    });

    previous?.addEventListener('click', () => render(activeIndex - 1, false, true));
    next?.addEventListener('click', () => render(activeIndex + 1, false, true));

    section.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      render(activeIndex + (event.key === 'ArrowRight' ? 1 : -1), true, true);
    });

    render(activeIndex);
  });
})();
